import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import { red, blue } from '@material-ui/core/colors';

import { getResumeDay } from '../../store/transactions/transactionsActions';
import useTypedSelector from '../../hooks/useTypedSelector';
import { formatBrl } from '../../utils';

export default function TransactionsResumeDay() {
  const {
    resumeDay,
    isLoading,
  } = useTypedSelector(({ transactionsState }) => ({
    resumeDay: transactionsState.resumeDay,
    isLoading: transactionsState.loadingResume,
  }));

  const [ day, setDay ] = useState( moment().format('YYYY-MM-DD') );
  const dispatch = useDispatch();

  useEffect(() => {
    if (day) {
      dispatch( getResumeDay(day) );
    }
  }, [ dispatch, day ]);

  return (
    <Box p={2}>
      <TextField
        type='date'
        label='Data'
        value={day}
        onChange={e => setDay(e.target.value)}
        style={{ marginBottom: 32 }}
      />
      {isLoading && (
        <LinearProgress />
      )}
      {resumeDay && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6}>
            <Typography style={{ color: blue[500] }} variant='h6' align='center'>
              Receitas
            </Typography>
            <Table>
              <TableBody>
                {resumeDay.incomes.map((item: any, i: number) => (
                  <TableRow key={i}>
                    <TableCell>{item.category}</TableCell>
                    <TableCell><b>{formatBrl(item.value)}</b></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Typography style={{ color: red[500] }} variant='h6' align='center'>
              Despesas
            </Typography>
            <Table>
              <TableBody>
                {resumeDay.expenses.map((item: any, i: number) => (
                  <TableRow key={i}>
                    <TableCell>{item.category}</TableCell>
                    <TableCell><b>{formatBrl(item.value)}</b></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
